export default __webpack_public_path__ + "static/media/Chain-swing.ee9cd475.webm";